import React, { useState } from "react";
import TabButton from './TabButtons'
import Header from "./Header";

const Calendar = ({ selectedDate, setSelectedDate }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const daysOfWeek = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
  const [startX, setStartX] = useState(0); // Начальная позиция касания
  const [isSwipeInProgress, setIsSwipeInProgress] = useState(false);
  const [isMonthView, setIsMonthView] = useState(false); // Новое состояние для отображения месяца

  const getDaysInWeek = (date) => {
    const startOfWeek = new Date(date);
    // Корректируем начало недели
    const day = startOfWeek.getDay();
    const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1);
    startOfWeek.setDate(diff);

    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(startOfWeek);
      day.setDate(startOfWeek.getDate() + i);
      days.push(day);
    }
    return days;
  };

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    let firstDayOfWeek = firstDay.getDay();
    firstDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

    const daysArray = [];

    // Добавляем дни предыдущего месяца
    const prevMonthLastDay = new Date(year, month, 0).getDate();
    for (let i = 0; i < firstDayOfWeek; i++) {
      const day = new Date(year, month - 1, prevMonthLastDay - firstDayOfWeek + i + 1);
      day.setHours(0, 0, 0, 0);
      daysArray.push({ date: day, isCurrentMonth: false });
    }

    // Добавляем дни текущего месяца
    for (let i = 1; i <= lastDay.getDate(); i++) {
      const day = new Date(year, month, i);
      day.setHours(0, 0, 0, 0);
      daysArray.push({ date: day, isCurrentMonth: true });
    }

    // Добавляем дни следующего месяца
    const remainingDays = 42 - daysArray.length;
    for (let i = 1; i <= remainingDays; i++) {
      const day = new Date(year, month + 1, i);
      day.setHours(0, 0, 0, 0);
      daysArray.push({ date: day, isCurrentMonth: false });
    }

    return daysArray;
  };

  const handleDayClick = (day) => {
    const selectedDay = new Date(day);
    selectedDay.setHours(12, 0, 0, 0); // Устанавливаем время на полдень во избежание проблем с часовыми поясами
    setSelectedDate(selectedDay);
  };

  const handlePrevWeek = () => {
    if (isMonthView) {
      setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
    } else {
      setCurrentDate(new Date(currentDate.setDate(currentDate.getDate() - 7)));
    }
  };

  const handleNextWeek = () => {
    if (isMonthView) {
      setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
    } else {
      setCurrentDate(new Date(currentDate.setDate(currentDate.getDate() + 7)));
    }
  };

  const handleTodayClick = () => {
    const today = new Date();
    today.setHours(12, 0, 0, 0);
    setCurrentDate(today);
    setSelectedDate(today);
  };

  const toggleCalendarView = () => {
    setIsMonthView(!isMonthView);
  };

  const calendarDays = isMonthView ? getDaysInMonth(currentDate) : getDaysInWeek(currentDate);

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX); // Сохраняем начальную позицию касания
  };

  const handleTouchMove = (e) => {
    if (isSwipeInProgress) return;

    const deltaX = e.touches[0].clientX - startX;
    if (Math.abs(deltaX) > 120) {
      setIsSwipeInProgress(true);
      if (deltaX > 0) {
        handlePrevWeek();
      } else {
        handleNextWeek();
      }
      setStartX(e.touches[0].clientX);
    }
  };

  const handleTouchEnd = () => {
    setIsSwipeInProgress(false);
  };

  return (
    <><Header />
      <div className="calendar">
        <div className="header">
          <div className="month-year">
            {currentDate.toLocaleString("default", { month: "long" }).charAt(0).toUpperCase() + currentDate.toLocaleString("default", { month: "long" }).slice(1)} {currentDate.getFullYear()}
          </div>
        </div>
        <div className="today-navigation">
          <button className="today-button" onClick={handleTodayClick}>Сегодня</button>
          <div className="month-navigation">
            <button className="nav-button prev" onClick={handlePrevWeek}>
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.38037 9.8803L4.88037 6.3803L8.38037 2.88029" strokeWidth="1.52993" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <span className="selected-date" onClick={toggleCalendarView}>{selectedDate.toLocaleDateString()}</span>
            <button className="nav-button next" onClick={handleNextWeek}>
              <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.61987 1.11971L5.11987 4.61971L1.61987 8.11971" strokeWidth="1.52993" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        <div className="days-of-week"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {daysOfWeek.map((day, index) => (
            <div key={index} className={`day-name ${index === 6 ? 'red' : ''} ${selectedDate && (selectedDate.getDay() === 0 ? 6 : selectedDate.getDay() - 1) === index ? 'selected' : ''}`}>{day}</div>
          ))}
        </div>
        <div className={`days ${isMonthView ? 'month-view' : ''}`}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {isMonthView ? (
            calendarDays.map((dayObj, index) => {
              const day = dayObj.date;
              const isEndOfMonth = day.getDate() === new Date(day.getFullYear(), day.getMonth() + 1, 0).getDate();
              const isSelected = selectedDate &&
                selectedDate.getDate() === day.getDate() &&
                selectedDate.getMonth() === day.getMonth() &&
                selectedDate.getFullYear() === day.getFullYear();
              const isSunday = day.getDay() === 0;

              return (
                <div
                  key={index}
                  className={`day-cell ${isSelected ? "selected" : ""} ${isEndOfMonth ? "month-end" : ""} ${isSunday ? "red" : ""} ${!dayObj.isCurrentMonth ? "other-month" : ""}`}
                  onClick={() => handleDayClick(new Date(day))}
                >
                  {day.getDate()}
                  <div className="dot" style={{ visibility: isSelected ? 'visible' : 'hidden' }} />
                </div>
              );
            })
          ) : (
            calendarDays.map((day, index) => {
              const isEndOfMonth = day.getDate() === new Date(day.getFullYear(), day.getMonth() + 1, 0).getDate();
              const isSelected = selectedDate &&
                selectedDate.getDate() === day.getDate() &&
                selectedDate.getMonth() === day.getMonth() &&
                selectedDate.getFullYear() === day.getFullYear();
              const isSunday = day.getDay() === 0;

              return (
                <div
                  key={index}
                  className={`day-cell ${isSelected ? "selected" : ""} ${isEndOfMonth ? "month-end" : ""} ${isSunday ? "red" : ""}`}
                  onClick={() => handleDayClick(new Date(day))}
                >
                  {day.getDate()}
                  <div className="dot" style={{ visibility: isSelected ? 'visible' : 'hidden' }} />
                </div>
              );
            })
          )}
        </div>
        <TabButton />
      </div>
    </>
  );
};

export default Calendar;
